<template>
  <div>
    <div>
      <q-btn
        style="padding: 0px; margin: 0px"
        color="black"
        flat
        icon="manage_search"
        round
        :disable="
          tipoTransferencia == 'transferencia_interna'
            ? false
            : ativo[1] == null
        "
        @click="modal = true"
      />
    </div>
    <q-dialog v-model="modal">
      <q-card class="modal-ativos">
        <q-card-section>
          <div class="text-h6 text-brand-5 text-weight-bold">
            Histórico do Ativo
          </div>
        </q-card-section>

        <q-card-section style="height: 400px" class="scrool">
          <q-linear-progress v-if="loading" indeterminate size="3px" />
          <div>
            <q-table
              flat
              :columns="
                tipoTransferencia == 'transferencia_interna'
                  ? columnsTransferenciaInterna
                  : columns
              "
              :rows="
                tipoTransferencia == 'transferencia_interna'
                  ? listaMovimentacao
                  : ativo
              "
              row-key="ativoUuid"
              dense
              :rows-per-page-options="[0]"
              no-data-label="Nenhum histórico encontrado."
              class="my-sticky-dynamic-ativo"
              hide-bottom
            >
              <template v-slot:header="props">
                <q-tr :props="props">
                  <q-th
                    class="text-weight-bolder"
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                  >
                    {{ col.label }}
                  </q-th>
                </q-tr>
              </template>
              <template v-slot:body="props">
                <q-tr
                  v-if="tipoTransferencia == 'transferencia_interna'"
                  class="text-brand-5 text-weight-bold"
                >
                  <q-td>
                    {{ props.row.tipo }}
                  </q-td>
                  <q-td>
                    {{ props.row.chave }}
                  </q-td>
                  <q-td>
                    {{
                      props.row?.etapa == "movimentacao_manual"
                        ? "Movimentação Manual"
                        : props.row?.etapa == "transferencia_interna_envio"
                        ? "Transferência Interna Envio"
                        : props.row?.etapa == "transferencia_externa_envio"
                        ? "Transferência Externa Envio"
                        : props.row?.etapa == "emprestimo"
                        ? "Empréstimo"
                        : props.row?.etapa == "movimentacao_manual_nf"
                        ? "Movimentação Manual NF"
                        : props.row?.etapa == "devolucao"
                        ? "Devolução"
                        : props.row?.etapa == "movimentacao_manual_voucher"
                        ? "Movimentação Manual Voucher"
                        : props.row?.etapa == "movimentacao_manual_romaneio"
                        ? "Movimentação Manual Romaneio"
                        : props.row?.etapa == "movimentacao_manual_estoque"
                        ? "Movimentação Manual Estoque"
                        : props.row?.etapa == "transferencia_interna"
                        ? "Transferência Interna"
                        : props.row?.etapa ==
                          "transferencia_interna_recebimento"
                        ? "Transferência Interna Recebimento"
                        : props.row?.etapa == "transferencia_externa"
                        ? "Transferência Externa"
                        : props.row?.etapa ==
                          "transferencia_externa_recebimento"
                        ? "Transferência Externa Recebimento"
                        : props.row?.etapa == "transferencia_manual_estoque"
                        ? "Transferência Manual Estoque"
                        : props.row?.etapa == "transferencia_manual_voucher"
                        ? "Transferência Manual Voucher"
                        : props.row?.etapa == "edicao_manual"
                        ? "Edição Manual"
                        : ""
                    }}
                  </q-td>
                  <q-td>
                    <span>
                      {{ props.row?.valorInicial }}
                    </span>
                  </q-td>
                  <q-td>
                    <span>
                      {{ props.row?.valorFinal }}
                    </span>
                  </q-td>
                  <q-td>
                    {{ props.row?.usuarioNome }}
                  </q-td>
                  <q-td>
                    {{
                      props.row?.alteradoEm
                        ?.split(" ")[0]
                        ?.split("-")
                        ?.reverse()
                        ?.join("/")
                    }}
                  </q-td>
                </q-tr>
                <q-tr v-else class="text-brand-5 text-weight-bold">
                  <q-td>
                    {{ props.rowIndex == 0 ? "Antes" : "Depois" }}
                  </q-td>
                  <q-td>
                    {{ props.row?.catalogoItem.codigo }}
                  </q-td>
                  <q-td>
                    {{ props.row?.catalogoItem.nome }}
                  </q-td>
                  <q-td>
                    {{ props.row?.patrimonio }}
                  </q-td>
                  <q-td>
                    {{ props.row?.preco }}
                  </q-td>
                  <q-td>
                    {{ props.row?.valorLocacao }}
                  </q-td>
                  <q-td>
                    {{ props.row?.tempoPermanencia }}
                  </q-td>
                  <q-td>
                    <div>
                      {{
                        props.row?.atualizadoEm
                          ?.split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}
                      <span class="row q-ml-sm">
                        {{ props.row?.atualizadoEm?.split(" ")[1] }}
                      </span>
                    </div>
                  </q-td>
                </q-tr>
              </template>
            </q-table>
            <div
              v-if="tipoTransferencia == 'transferencia_interna'"
              class="row justify-center q-mt-md"
            >
              <q-pagination
                :disable="disable"
                v-model="pagination.page"
                color="brand-5"
                active-color="secondary"
                active-text-color="white"
                :max="pagesNumber"
                :max-pages="5"
                :boundary-numbers="false"
                :direction-links="true"
                :size="mobile ? 'md' : 'sm'"
              />
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "historico",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descrição",
    label: "Descrição",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
  },
  {
    name: "preco",
    label: "Preço",
    align: "left",
  },
  {
    name: "valorLocacao",
    label: "Valor Locação",
    align: "left",
  },
  {
    name: "tempoPermanencia",
    label: "Tempo de Permanência",
    align: "left",
  },
  {
    name: "alteradoEm",
    label: "Data de Alteração",
    align: "left",
  },
];

const columnsTransferenciaInterna = [
  {
    name: "tipo",
    label: "Tipo",
    align: "left",
  },
  {
    name: "chave",
    label: "Chave",
    align: "left",
  },
  {
    name: "etapa",
    label: "Etapa",
    align: "left",
  },
  {
    name: "valorInicial",
    label: "Valor Inicial",
    align: "left",
  },
  {
    name: "valorFinal",
    label: "Valor Final",
    align: "left",
  },
  {
    name: "usuario",
    label: "Usuário",
    align: "left",
  },
  {
    name: "alteradoEm",
    label: "Alterado Em",
    align: "left",
  },
];
export default {
  props: ["ativo", "tipoTransferencia", "ativoUuid"],
  setup(props) {
    const store = useStore();
    const quasar = useQuasar();

    const loading = ref(false);
    const modal = ref(false);
    const listaMovimentacao = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const disable = ref(false);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarHistoricoAtivo = async (page = 1, perPage = 10) => {
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarMovimentacaoAtivo",
          {
            ativoUuid: props.ativoUuid,
            chave: "patrimonio",
            page,
            perPage,
          }
        );
        listaMovimentacao.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        disable.value = false;
        loading.value = false;
        console.log(error);
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        listarHistoricoAtivo(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => modal.value,
      () => {
        if (props.tipoTransferencia == "transferencia_interna") {
          listarHistoricoAtivo();
        }
      }
    );

    return {
      columns,
      loading,
      modal,
      store,
      disable,
      listaMovimentacao,
      columnsTransferenciaInterna,
      mobile,
      listarHistoricoAtivo,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic-ativo {
  max-height: 300px;
}
.modal-ativos {
  min-width: 1400px;
}
@media (max-width: 600px) {
  .modal-ativos {
    min-width: 100%;
  }
}
</style>
